export default {
  namespaced: true,
  state: {
    department: null,
  },
  mutations: {
    setDepartment(state, data) {
      state.department = data
    },

  },
  getters: {
    currentDepartment: state => state.department,
  },
  actions: {

    SET_DEPARTMENT: function ({commit}, data) {
      commit('setDepartment', data);
    }

  }
};
